import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OnlineEventType } from '@core/enums/event/online-event-type.enum';
import { EventListItem } from '@core/models/event/event-list-item.model';
import { StoreService } from '@core/services/store/store.service';
import { AAGUID, DateTimeFormat } from '@interticket/core';

@Component({
  selector: 'event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCardComponent implements OnInit {

  readonly dateTimeFormat = DateTimeFormat;
  readonly onlineEventType = OnlineEventType;
  partnerName: string;

  @Input() readonly event: EventListItem;
  @Output() readonly onBuyTicket = new EventEmitter<AAGUID>();
  @Output() readonly hasNoTicket = new EventEmitter<void>();

  constructor(private storeService: StoreService) { }

  ngOnInit(): void {
    this.partnerName = this.storeService.partnerConfig.partnerName;
  }

  buyTicket(eventId: AAGUID): void {
    this.onBuyTicket.emit(eventId);
  }

}
